/**
 * useFarmMembers (HOF-627 §12 T0) — the Team list. Used only by ``TeamMembersList``, which
 * mounts when the section is opened, so ``<SettingsPage />``'s own render stays hook-free
 * (it has no ``QueryClientProvider``; see ``OwnOrganisationsSection.tsx``).
 */
import { useQuery } from '@tanstack/react-query';
import { fetchFarmMembers, type FarmMembersResponse } from './farmMembers';

export const farmMemberKeys = {
    all: ['farm', 'members'] as const,
};

export function useFarmMembers() {
    return useQuery<FarmMembersResponse>({
        queryKey: farmMemberKeys.all,
        queryFn: fetchFarmMembers,
        staleTime: 30_000,
    });
}
